import loadConfigFile from '~/plugins/config/loadConfigFile'

export default (conf) => {
  return loadConfigFile(`branding/${conf}.json`)
}
